"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateSpecificToolTips = exports.zendeskInfoByStateWithKeys = exports.additionalDriverDiscountsTypesByStates = exports.courseDiscountTypeByStates = exports.alabamaLogicInstallmentFeeStates = exports.myCommunityDiscountStateCaps = exports.vouchDiscountStateCaps = exports.vouchDiscountStates = exports.homeCoveragesToSave = exports.autoCoveragesToSave = exports.noUmbrellaStates = exports.disableExcludeDriverStates = exports.stackedUMStates = exports.uimPremiumCoverageArray = exports.umPremiumCoverageArray = exports.umUimCoverageArray = exports.validZipCodeRanges = exports.maximumNewHomeDiscountHomeAgeByState = exports.wipeOutNonBranchAutoCancelsOnTermByState = exports.excludedDriverSignsStates = exports.expandedRoofTypeStates = exports.architecturalShinglesStates = exports.noDPROStates = exports.noADNOStates = exports.noADTRStates = exports.noADDIStates = exports.noADNRStates = exports.noRCOMStates = exports.noROSEStates = exports.noROFEStates = exports.noROOSStates = exports.noROOFStates = exports.noROFMStates = exports.noANMLStates = exports.gbckFormStates = exports.rtnoFormStates = exports.belcnFormStates = exports.aelcnFormStates = exports.tpanFormStates = exports.wgptFormStates = exports.discFormStates = exports.adwrFormStates = exports.shortRateFeeStates = exports.noTrailerCoverageStates = exports.noConnectedHomeProviderSpecialOfferByState = exports.restrictedPurchaseStates = exports.branchLiveStates = exports.insurancePaper = exports.everspanStates = exports.bixStates = void 0;
exports.rceMinimum = exports.rceLimitOnline = exports.yearBuiltMinimum = exports.neverLoseUmbrellaByState = exports.neverLoseCommunityDriveParticipationByState = exports.maxValueForAFNClassification = exports.ratingLookbackByState = exports.disqualifyingChargesByState = exports.windHailExclusionDistanceToCeanCodesStates = exports.ineligibleDistanceToOceanCodesStates = exports.ineligibleForUWHomeClaimGroupStates = exports.stateSpecificAutoUnderwriting = exports.noPPCExclusionStates = exports.driverViolationsDisqualifyingCourseDiscountStates = exports.altCreditAlgorithmStates = exports.minPremiumCheckStates = exports.assignDriversToCarsStates = exports.vermontExcessDriversRatingRules = exports.excessCarsByDriverCarAssignmentStates = exports.noUMPDIfCollisionOnCarStates = exports.CCWStates = exports.pullAutoDataOnlyForAutoPolicyStates = exports.windstormMitigationDiscountStates = exports.coverageRSForcedStates = exports.coverageRSExtendedForcedStates = exports.enhancedRoofWindstormStates = exports.defaultCommunityDriveStates = exports.noMedPayStates = exports.noUMPDStates = exports.UMPDOnlyWithUMBIStates = exports.policyLevelUMPDStates = exports.separate3NAFsCheckStates = exports.branchClaimCountJustAAFStates = exports.combinedUMUIM = exports.UMBIEqualsBIStates = exports.SouthDakotaUMBIRulesStates = exports.specificExcludedDriversStates = exports.noExcludedDriversStates = exports.noUDRsAllowedStates = exports.mandatoryPIP = exports.mandatoryUM = exports.mandatoryPolicyUMPD = exports.percentageWindHailDeductible = exports.homeownersRights = exports.limitedBranchWindhailCoverage = exports.mandatoryWindHailDeductible = exports.hurricaneDeductibleStates = exports.statesWith250PD = exports.courseDiscountsAges = exports.seniorDiscountByAgeOnlyStates = void 0;
exports.coverageCANotOffered = exports.coverageDNotOffered = exports.coverageFOffered = exports.fixableRejectionCodes = exports.rejectCodesToBeClearedInStaff = exports.rejectCodes = exports.errorCodes = exports.communityDriveAvailableStates = exports.changeRejectionLangToNeedToTalkStates = exports.umpdDeductibleByState = exports.policyLevelAndCopyToCarUMPDStates = exports.incomeLossStates = exports.coverageRSDescriptionStates = exports.coverageRSLabelStates = exports.incomeLossLabelStates = exports.accidentalDeathStates = exports.pipStates = exports.discountPaperlessStates = exports.discountInventoryScoreStates = exports.advancedConnectedHomeStates = exports.leaseLoanStates = exports.policyLimitUMPDDefaultStates = exports.noFaultPIPDefaultStates = exports.guestPIPDefaultStates = exports.pipDefaultStates = exports.coverageSTDefaultStates = exports.coverageJDefaultStates = exports.coverageDPctOfADefaultStates = exports.coverageBPDefaultStates = exports.coverageIBSCDefaultStates = exports.uninsuredMotoristDefaultStates = exports.windHailDeductibleDefaultStates = exports.basementTypes = exports.minLimitRentalStates = exports.claimLimitRentalStates = exports.driverCarAssignmentStates = exports.fcraDriverRiskStates = exports.driversLicenseNotRequiredStates = exports.mvrPostBindStates = exports.mvrAlsoPreBindStates = exports.preBindMVRStates = exports.mvrStates = exports.roofSurfacesExtendedCompositionMaxAge = exports.sewerBackupStates = exports.coverageBPInsideLimitStates = exports.waterBackupDeductibleFixedStates = exports.waterBackupDeductibleStates = exports.waterBackupNameIncludedIncreasedByState = exports.waterBackupNameByState = exports.autoViolationNoRateCodes = void 0;
exports.paymentType = exports.paymentMethod = exports.planType = exports.policyType = exports.priorLapseDays = exports.financialResponsibilityTiersImpactingPrice = exports.fpcClassesImpactingPrice = exports.homeClaimCodeToDescription = exports.violationCodeToDescription = exports.connectedHomeProvidersAllowingVerification = exports.homeClaimPoints = exports.monarchPoints = exports.ratingSeriousness = exports.HighestEducation = exports.connectedHomePromoDetails = exports.newCustomersDefaultDevices = exports.mortgageClauses = exports.mortgageHoldersAffinities = exports.HomeSecurityPartnerCustomerType = exports.vehicleEquipmentStatusCode = exports.minimumDrivingAge = exports.statePremiumTaxStates = exports.localPremiumTaxStates = exports.pipCheckStates = exports.rentersPolicyAvailable = exports.noWindHailDeductibleStates = exports.windHailDeductibleCanVaryByCounty = exports.aopDeductibleIsAlwaysPercent = exports.windHailDeductibleIsAlwaysPercent = exports.mandatoryWindHailDeductibleByCounty = exports.mandatoryWindHailDeductibleByZip = exports.mandatoryWindHailDeductibleValueMinimumStates = exports.coastalCounties = exports.ineligibleCoastalCities = exports.mineSubsidenceRequired = exports.mineSubsidenceOptional = exports.mineSubsidenceDefaulted = exports.mineSubsidenceStates = exports.mineSubsidenceMaxStates = exports.buildingMaterialsTheftCoverageByState = exports.firelineCutoffsByState = exports.additionalPPCIneligibleByState = exports.offerExcessUM = exports.coverageHomeownerProtectionNotOffered = exports.coverageYardAndGardenNotOffered = exports.coverageFairRentalNotOffered = exports.coverageSPNotOffered = exports.coverageSTNotOffered = exports.coverageMINotOffered = exports.coverageDRNotOffered = void 0;
exports.driversLicenseRegexByState = exports.equipmentBreakdownServiceLineCoveragesStates = exports.mustRenewAutoLimit = exports.hideGenderStates = exports.hideHighestEducationStates = exports.excludeBIXMonolineUnderwritingStates = exports.annualMilesDrivenLimits = exports.floodStates = exports.palomarErrorPreventPurchasingStates = exports.earthquakeStates = exports.uimCoverageTypeStates = exports.editableHouseholdMembersStates = exports.stormShuttersStates = exports.specificDriverAgeLogicStates = exports.passiveRestraintStates = exports.cancelCodeInformationalArray = exports.cancelNoticeParagraphText = exports.onboardingTasks = exports.normalizedPaymentStatus = exports.stripeChargeStatus = exports.stripeBankStatus = void 0;
const courseDiscountTypes = {
    AVOIDANCE: 'AVOIDANCE',
    DEFENSIVE: 'DEFENSIVE',
    PREVENTION: 'PREVENTION',
    SENIOR: 'SENIOR',
    MILITARY_DEFENSIVE: 'MILITARY_DEFENSIVE'
};
exports.bixStates = {
    AZ: true,
    IA: true,
    IN: true,
    KY: true,
    MD: true,
    MI: true,
    MO: true,
    ND: true,
    NE: true,
    NM: true,
    OH: true,
    OK: true,
    OR: true,
    PA: true,
    TX: true,
    UT: true,
    WI: true,
    WV: true
};
exports.everspanStates = {
    ID: true,
    NH: true,
    SD: true,
    TN: true,
    VT: true
};
exports.insurancePaper = {
    EVERSPAN: 'EVERSPAN',
    GSNIC: 'GSNIC',
    BIX: 'BIX'
};
exports.branchLiveStates = [
    'AL',
    'AZ',
    'CO',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'MD',
    'MI',
    'MO',
    'NE',
    'NH',
    'NM',
    'OH',
    'OK',
    'PA',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'WI',
    'WV'
];
exports.restrictedPurchaseStates = ['MI'];
exports.noConnectedHomeProviderSpecialOfferByState = { MD: ['SimpliSafe'] };
exports.noTrailerCoverageStates = ['CO', 'NJ', 'NY', 'VA'];
exports.shortRateFeeStates = {
    VA: true
};
exports.adwrFormStates = {
    AZ: true,
    CO: false,
    IA: true,
    ID: false,
    IN: true,
    KY: true,
    MD: true,
    MI: false,
    MO: true,
    ND: true,
    NE: true,
    NH: true,
    NM: false,
    OH: true,
    OK: true,
    OR: true,
    PA: false,
    TN: true,
    TX: true,
    UT: true,
    VA: false,
    WI: true,
    WV: true
};
exports.discFormStates = {
    CO: true,
    VT: true
};
exports.wgptFormStates = {
    OH: true,
    WI: true
};
exports.tpanFormStates = {
    NH: true
};
exports.aelcnFormStates = {
    VA: true
};
exports.belcnFormStates = {
    IA: true,
    MI: true,
    NH: true,
    IL: true,
    NM: true,
    OK: true,
    TX: true,
    VT: true
};
exports.rtnoFormStates = {
    MI: true,
    NH: true
};
exports.gbckFormStates = {
    AL: true,
    AZ: true,
    CO: true,
    IA: true,
    ID: false,
    IN: true,
    KY: true,
    MD: true,
    MI: true,
    ND: true,
    NE: true,
    NH: false,
    NM: true,
    OH: true,
    OK: true,
    OR: true,
    PA: false,
    SD: true,
    TN: true,
    TX: true,
    UT: true,
    VA: false,
    VT: true,
    WI: true,
    WV: true
};
exports.noANMLStates = {
    IA: true,
    ND: true,
    NH: true,
    VA: true,
    VT: true
};
exports.noROFMStates = {
    ND: true,
    NH: true,
    NM: true,
    VT: true
};
exports.noROOFStates = {
    ND: true,
    NH: true,
    NM: true,
    VA: true,
    WV: true,
    VT: true
};
exports.noROOSStates = {
    ND: true,
    NH: true,
    NM: true,
    VA: true,
    WV: true,
    VT: true
};
exports.noROFEStates = {
    ND: true,
    NH: true,
    NM: true,
    VA: true,
    VT: true
};
exports.noROSEStates = {
    ND: true,
    NH: true,
    NM: true,
    VA: true,
    WV: true,
    VT: true
};
exports.noRCOMStates = {
    ND: true,
    NH: true,
    NM: true,
    VA: true,
    WV: true,
    VT: true
};
exports.noADNRStates = {
    ND: true
};
exports.noADDIStates = {
    ND: true
};
exports.noADTRStates = {
    ND: true
};
exports.noADNOStates = {
    ND: true
};
exports.noDPROStates = {
    IA: true
};
exports.architecturalShinglesStates = {
    SD: true
};
exports.expandedRoofTypeStates = {
    ND: true,
    NH: true,
    SD: true,
    VT: true
};
exports.excludedDriverSignsStates = {
    UT: true
};
exports.wipeOutNonBranchAutoCancelsOnTermByState = {
    VA: 7
};
exports.maximumNewHomeDiscountHomeAgeByState = {
    NH: 49,
    SD: 49,
    VT: 49
};
/**
 * Valid Zip Codes can be represented as either a single value, or "tuples" containing the min & max values of a range.
 * Values are inclusive.
 */
exports.validZipCodeRanges = {
    AL: [[35000, 39999]],
    AZ: [[85001, 86556]],
    CO: [[80001, 82000]],
    IA: [[50001, 52999]],
    ID: [[83000, 84000]],
    IL: [[60001, 62999]],
    IN: [[46001, 47997]],
    KS: [[66000, 69999]],
    KY: [[40001, 43999]],
    MD: [[20331, 21999]],
    MI: [[48001, 49999]],
    MO: [[63001, 65899]],
    ND: [[58100, 58999]],
    NE: [[68001, 69999]],
    NH: [[3000, 3999]],
    NM: [[87001, 89999]],
    OH: [[43001, 45999]],
    OK: [[73001, 74999]],
    OR: [[97000, 97999]],
    PA: [[15001, 19999]],
    SD: [[57001, 57999]],
    TN: [[37000, 39999]],
    TX: [[73301, 88589]],
    UT: [[84000, 84999]],
    VA: [[20000, 24999]],
    VT: [[5000, 5999]],
    WI: [[53001, 55000]],
    WV: [[24000, 26999]]
};
exports.umUimCoverageArray = {
    AL: ['UM'],
    AZ: ['UM_UIM'],
    CO: ['UM_UIM'],
    IA: ['UM', 'UIM'],
    ID: ['UM', 'UIM'],
    IL: ['UMUIM', 'UM_UIM'],
    IN: ['UM_UIM'],
    KS: ['UMUIM'],
    KY: ['UM', 'UIM'],
    MD: ['UM', 'EUIM'],
    MO: ['UM', 'UIM'],
    MI: ['UMUIM'],
    ND: ['UM', 'UIM'],
    NE: ['UM', 'UIM'],
    NH: ['UM', 'UIM'],
    NM: ['UMUIM'],
    OH: ['UM_UIM'],
    OK: ['UM'],
    OR: ['UM'],
    PA: ['UM', 'UIM'],
    SD: ['UM', 'UIM'],
    TN: ['UM'],
    TX: ['UMUIMBI', 'UMUIMPD'],
    UT: ['UM', 'UIM'],
    VA: ['UMUIM'],
    VT: ['UM', 'UIM'],
    WI: ['UM', 'UIM'],
    WV: ['UMBI', 'UIMBI']
};
exports.umPremiumCoverageArray = {
    AL: ['UM_UIM'],
    AZ: ['UM_UIM'],
    CO: ['UM_UIM'],
    IA: ['UM'],
    ID: ['UM'],
    IL: ['UMUIM', 'UM_UIM'],
    IN: ['UM_UIM'],
    KS: ['UM'],
    KY: ['UM'],
    MD: ['UM'],
    MO: ['UM'],
    MI: ['UMUIM'],
    ND: ['UM'],
    NE: ['UM'],
    NH: ['UM'],
    NM: ['UMUIM'],
    OH: ['UM_UIM'],
    OK: ['UM'],
    OR: ['UM'],
    PA: ['UM'],
    SD: ['UM'],
    TN: ['UM'],
    TX: ['UMUIMBI', 'UMUIMPD'],
    UT: ['UM'],
    VA: ['UMUIM'],
    VT: ['UM'],
    WI: ['UM'],
    WV: ['UMBI']
};
exports.uimPremiumCoverageArray = {
    AL: [],
    AZ: [],
    CO: [],
    IA: ['UIM'],
    ID: ['UIM'],
    IL: [],
    IN: [],
    KS: [],
    KY: ['UIM'],
    MD: ['EUIM'],
    MO: ['UIM'],
    MI: [],
    ND: ['UIM'],
    NE: ['UIM'],
    NH: ['UIM'],
    NM: [],
    OH: [],
    OK: [],
    OR: [],
    PA: ['UIM'],
    SD: ['UIM'],
    TN: [],
    TX: [],
    UT: ['UIM'],
    VA: [],
    VT: ['UIM'],
    WI: ['UIM'],
    WV: ['UIMBI']
};
exports.stackedUMStates = { NM: true, PA: true };
exports.disableExcludeDriverStates = {
    IA: true,
    KS: true,
    MI: true,
    NH: true,
    OR: true,
    VA: true,
    VT: true,
    WI: true
};
exports.noUmbrellaStates = { KS: true, WV: true };
exports.autoCoveragesToSave = [
    'BI',
    'PD',
    'UM',
    'UIM',
    'UMBI',
    'UIMBI',
    'UM_UIM',
    'EUIM',
    'EUIMPD',
    'UMPD',
    'UIMPD',
    'UMUIM',
    'UMUIMBI',
    'UMUIMPD',
    'COMP',
    'COLL',
    'MED',
    'PIP',
    'APIP',
    'GPIP',
    'TRNSP',
    'ROAD',
    'ACPE',
    'ACQ_EXP',
    'OPS_EXP',
    'CONTENTS',
    'COMP_TRLR',
    'COLL_TRLR',
    'LOAN',
    'LPD',
    'PPI',
    'ME',
    'WL',
    'ACR',
    'INCM_LOSS',
    'COMBO_FPB',
    'FNRL_BEN',
    'MED_EXP',
    'ACC_DTH',
    'PIP_scenarios',
    'GPIP_scenarios',
    'affinity_discount_savings',
    'total_statutory_otherLiability',
    'total_statutory_PIP',
    'total_statutory_physDam',
    'UM_25_50_UMPD_25',
    'UM_100_300_UMPD_50'
];
exports.homeCoveragesToSave = [
    'cov_ms_premium',
    'affinity_discount_savings',
    'connected_home_discount_savings',
    'wind',
    'hurricane',
    'covEB',
    'covSL'
];
exports.vouchDiscountStates = {
    AL: true,
    AZ: true,
    CO: true,
    MD: true,
    MO: true,
    IA: true,
    IL: true,
    IN: true,
    KS: true,
    KY: true,
    MI: true,
    ND: true,
    NE: true,
    NH: true,
    NM: true,
    OH: true,
    OK: true,
    OR: true,
    PA: true,
    SD: true,
    TN: true,
    TX: false,
    UT: true,
    VA: true,
    VT: true,
    WI: true,
    WV: true
};
exports.vouchDiscountStateCaps = {
    AL: 5,
    AZ: 5,
    CO: 5,
    MD: 5,
    MO: 5,
    IA: 5,
    ID: 5,
    IL: 5,
    IN: 5,
    KS: 5,
    KY: 5,
    MI: 5,
    ND: 5,
    NH: 5,
    NM: 5,
    OH: 5,
    OK: 5,
    OR: 5,
    SD: 5,
    TN: 5,
    TX: 0,
    UT: 5,
    VA: 5,
    VT: 5,
    WI: 5,
    WV: 5
};
exports.myCommunityDiscountStateCaps = {
    AZ: 25,
    IA: 0,
    ID: 0,
    IL: 0,
    IN: 0,
    KY: 0,
    MO: 50,
    NH: 0,
    NM: 0,
    OH: 0,
    SD: 0,
    TX: 0,
    VT: 0,
    WV: 0
};
exports.alabamaLogicInstallmentFeeStates = {
    AL: true
};
exports.courseDiscountTypeByStates = {
    AL: courseDiscountTypes.SENIOR,
    AZ: false,
    CO: courseDiscountTypes.SENIOR,
    IA: false,
    ID: courseDiscountTypes.SENIOR,
    IL: courseDiscountTypes.SENIOR,
    IN: false,
    KS: courseDiscountTypes.AVOIDANCE,
    KY: courseDiscountTypes.SENIOR,
    MI: false,
    MO: false,
    ND: false,
    NH: false,
    NE: false,
    NM: courseDiscountTypes.SENIOR,
    OH: courseDiscountTypes.SENIOR,
    OK: courseDiscountTypes.DEFENSIVE,
    OR: courseDiscountTypes.SENIOR,
    PA: courseDiscountTypes.DEFENSIVE,
    SD: courseDiscountTypes.SENIOR,
    TN: courseDiscountTypes.SENIOR,
    TX: false,
    UT: courseDiscountTypes.SENIOR,
    VT: false,
    WI: false,
    WV: courseDiscountTypes.SENIOR
};
exports.additionalDriverDiscountsTypesByStates = {
    // this allows for only one additional discount, will need refactor if we end up with states where driver can have 3+ discounts offered
    KY: {
        condition: 'IS_ACTIVE_DUTY',
        discountType: courseDiscountTypes.MILITARY_DEFENSIVE
    }
};
exports.zendeskInfoByStateWithKeys = {
    KY: {
        IS_ACTIVE_DUTY: 'has taken a voluntary accident prevention course provided by the Armed Forces in the last 5 years.',
        SENIOR: 'has taken an Accident Prevention Course approved by the Transportation Cabinet of Kentucky within the last 5 years.'
    }
};
exports.stateSpecificToolTips = {
    KY: 'discountCourseKY'
};
exports.seniorDiscountByAgeOnlyStates = {
    MI: 65,
    KY: 55
};
exports.courseDiscountsAges = {
    AL: 55,
    CO: 55,
    ID: 55,
    IL: 60,
    KS: 1,
    KY: 55,
    NM: 55,
    OH: 60,
    OK: 1,
    OR: 55,
    PA: 55,
    SD: 55,
    TN: 55,
    UT: 55,
    VA: 60,
    WV: 55
};
exports.statesWith250PD = ['MD', 'OH', 'PA', 'WI'];
exports.hurricaneDeductibleStates = {
    AZ: false,
    CO: false,
    IL: false,
    IN: false,
    KS: false,
    MO: false,
    OH: false,
    TX: false
};
exports.mandatoryWindHailDeductible = {};
exports.limitedBranchWindhailCoverage = { AL: true, GA: true };
exports.homeownersRights = {
    AL: 'https://www.aldoi.gov/PDF/Consumers/HomeownersBillofRightsAct.pdf'
};
/** States that, when they have a minimum % deductible, only allow % deductibles */
exports.percentageWindHailDeductible = { MD: true };
exports.mandatoryPolicyUMPD = { MD: true, VT: true };
exports.mandatoryUM = { IL: true, MD: true, MO: true, ND: true, OR: true, SD: true, VT: true };
exports.mandatoryPIP = { KS: true, MD: true, ND: true, OR: true };
exports.noUDRsAllowedStates = ['IN', 'MD'];
exports.noExcludedDriversStates = ['KS', 'NH', 'OR', 'VA', 'VT', 'WI'];
exports.specificExcludedDriversStates = ['IA'];
exports.SouthDakotaUMBIRulesStates = {
    SD: true
};
exports.UMBIEqualsBIStates = {
    NH: true
};
exports.combinedUMUIM = {
    AL: true,
    AZ: false,
    CO: true,
    IA: true,
    ID: false,
    IL: true,
    IN: true,
    KS: true,
    MD: true,
    MI: true,
    MO: false,
    ND: true,
    NE: true,
    NH: true,
    NM: true,
    OH: true,
    OK: true,
    OR: true,
    PA: false,
    SD: true,
    TN: true,
    TX: true,
    UT: false,
    VA: true,
    VT: true,
    WI: false,
    WV: false
};
exports.branchClaimCountJustAAFStates = { OR: true };
exports.separate3NAFsCheckStates = { MD: true };
exports.policyLevelUMPDStates = { IN: true, MD: true, TN: true, TX: true, VA: true, WV: true };
exports.UMPDOnlyWithUMBIStates = { ID: true, UT: true, MD: true, TN: true };
exports.noUMPDStates = { AL: true, IA: true, MI: true, ND: true, NH: true, SD: true };
exports.noMedPayStates = { MI: true, MD: true, ND: true, OR: true, UT: true };
exports.defaultCommunityDriveStates = { AZ: true, CO: true };
exports.enhancedRoofWindstormStates = { SC: true };
exports.coverageRSExtendedForcedStates = { ND: true, NH: true, NM: true, WV: true, VA: true, VT: true };
exports.coverageRSForcedStates = {};
exports.windstormMitigationDiscountStates = { AL: true };
exports.pullAutoDataOnlyForAutoPolicyStates = {
    AK: true,
    DC: true,
    GA: true,
    MA: true,
    ND: true,
    NH: true,
    SC: true,
    VT: true
};
/** CCW violation type */
exports.CCWStates = { AL: true };
exports.noUMPDIfCollisionOnCarStates = { VA: true };
exports.excessCarsByDriverCarAssignmentStates = { VA: true };
exports.vermontExcessDriversRatingRules = { VT: true };
exports.assignDriversToCarsStates = { VA: true, VT: true };
exports.minPremiumCheckStates = { VA: 10 };
exports.altCreditAlgorithmStates = {
    KS: true,
    FL: true,
    SC: true
};
exports.driverViolationsDisqualifyingCourseDiscountStates = {
    AL: ['AAF', 'CRD', 'DR', 'FEL', 'FLE', 'HOM', 'LDL', 'LTS', 'MAJ', 'RKD', 'SUS', 'DWI']
};
exports.noPPCExclusionStates = { KY: true, MI: true, NH: true };
exports.stateSpecificAutoUnderwriting = { MI: true };
exports.ineligibleForUWHomeClaimGroupStates = {
    MD: ['F', 'G']
};
exports.ineligibleDistanceToOceanCodesStates = {
    MD: ['01', '02', '03', '04', '05', '06', '1', '2', '3', '4', '5', '6'],
    VA: ['01', '02', '03', '04', '05', '06', '1', '2', '3', '4', '5', '6']
};
exports.windHailExclusionDistanceToCeanCodesStates = {
    GA: ['01', '02', '03', '04', '05', '06', '1', '2', '3', '4', '5', '6']
};
exports.disqualifyingChargesByState = {
    MD: ['CRD', 'DR', 'DWI', 'FDL', 'FEL', 'FLE', 'FSV', 'HOM', 'LDL', 'LTS', 'RKD', 'SLV', 'SUS'],
    MI: ['CRD', 'DR', 'DWI', 'FEL', 'FLE', 'FSV', 'HOM', 'LDL', 'LTS', 'RKD', 'SLV', 'SUS']
};
exports.ratingLookbackByState = {
    KS: 35,
    MD: 35,
    PA: 35
};
exports.maxValueForAFNClassification = {
    PA: 1900
};
exports.neverLoseCommunityDriveParticipationByState = {
    PA: true
};
exports.neverLoseUmbrellaByState = {
    PA: true
};
exports.yearBuiltMinimum = {
    MI: 1600
};
exports.rceLimitOnline = {
    AL: 950000,
    AZ: 950000,
    CO: 950000,
    IA: 950000,
    ID: 950000,
    IL: 950000,
    IN: 950000,
    KS: 950000,
    KY: 950000,
    MD: 950000,
    MI: 950000,
    MO: 950000,
    ND: 950000,
    NE: 950000,
    NH: 950000,
    NM: 950000,
    OH: 950000,
    OR: 950000,
    PA: 950000,
    SD: 950000,
    TN: 850000,
    TX: 850000,
    UT: 950000,
    VA: 950000,
    VT: 950000,
    WI: 950000,
    WV: 950000
};
exports.rceMinimum = {
    MI: 50000
};
exports.autoViolationNoRateCodes = {
    IA: ['NAF', 'CMP', 'CMU'],
    MO: ['PUN', 'NAF', 'CMP', 'CMU'],
    ND: ['NAF', 'CMP', 'CMU'],
    NH: ['NAF', 'CMP', 'CMU'],
    TN: ['CMP', 'CMU'],
    TX: ['PUN', 'CMP', 'CMU'],
    VT: ['ANO', 'ANC', 'PUA', 'NAF', 'CMP', 'CMU']
};
exports.waterBackupNameByState = {
    MD: 'Sewer Backup'
};
exports.waterBackupNameIncludedIncreasedByState = {
    VA: true
};
exports.waterBackupDeductibleStates = {
    ND: true,
    NH: true,
    SD: true
};
exports.waterBackupDeductibleFixedStates = {
    OR: 1000
};
exports.coverageBPInsideLimitStates = {
    KS: 2500,
    ND: 2500
};
exports.sewerBackupStates = {
    MD: true
};
exports.roofSurfacesExtendedCompositionMaxAge = {
    AL: 15,
    AZ: 15,
    CO: 15,
    IA: 15,
    ID: 15,
    IL: 15,
    IN: 15,
    KS: 15,
    KY: 15,
    MD: 15,
    MI: 15,
    MO: 10,
    ND: 15,
    NE: 15,
    NM: 15,
    OH: 15,
    OK: 15,
    OR: 15,
    PA: 15,
    SD: 15,
    TN: 15,
    TX: 15,
    UT: 15,
    VA: 15,
    VT: 15,
    WI: 15,
    WV: 15
};
exports.mvrStates = ['CA', 'MO', 'MN', 'OH'];
// these are the states in which we want to force pulling MVRs before binding
exports.preBindMVRStates = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
];
exports.mvrAlsoPreBindStates = ['MI'];
exports.mvrPostBindStates = [
    'AL',
    'AR',
    'CO',
    'DC',
    'DE',
    'ID',
    'KS',
    'KY',
    'LA',
    'MA',
    'ME',
    'MI',
    'MS',
    'MT',
    'NC',
    'NH',
    'NE',
    'NY',
    'SC',
    'VA',
    'VT',
    'WV'
];
exports.driversLicenseNotRequiredStates = [
    'AK',
    'AZ',
    'CA',
    'CT',
    'FL',
    'GA',
    'HI',
    'IA',
    'IL',
    'IN',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'WA',
    'WI',
    'WY'
];
exports.fcraDriverRiskStates = [
    'AK',
    'AZ',
    'CT',
    'FL',
    'GA',
    'HI',
    'IA',
    'IL',
    'IN',
    'MD',
    'ND',
    'NM',
    'NJ',
    'NV',
    'OK',
    'OR',
    'PA',
    'RI',
    'SD',
    'TN',
    'TX',
    'UT',
    'WA',
    'WI',
    'WY'
];
exports.driverCarAssignmentStates = {
    VA: true,
    VT: true
};
exports.claimLimitRentalStates = {
    VA: true
};
exports.minLimitRentalStates = {
    AL: 40,
    AZ: 40,
    CO: 40,
    IA: 40,
    ID: 40,
    IL: 40,
    IN: 40,
    KS: 40,
    KY: 40,
    MD: 40,
    MI: 40,
    MO: 40,
    ND: 40,
    NE: 40,
    NM: 40,
    OH: 40,
    OK: 40,
    OR: 40,
    PA: 40,
    SD: 40,
    TN: 40,
    TX: 40,
    UT: 40,
    VA: 600,
    VT: 40,
    WI: 40,
    WV: 40
};
exports.basementTypes = {
    Slab: 'S',
    Raised: 'R',
    Unfinished: 'U',
    PartialFinished: 'PF',
    FullFinished: 'FF'
};
exports.windHailDeductibleDefaultStates = {
    MO: 0.01,
    OK: 0.01,
    SD: 0.01
};
exports.uninsuredMotoristDefaultStates = {
    VT: '1000000'
};
exports.coverageIBSCDefaultStates = {
    IA: 20,
    SD: 20
};
exports.coverageBPDefaultStates = {
    KS: 2500,
    ND: 2500
};
exports.coverageDPctOfADefaultStates = {
    ND: 10,
    VT: 10
};
exports.coverageJDefaultStates = {
    ND: 1000,
    NH: 1000,
    SD: 1000,
    VT: 1000
};
exports.coverageSTDefaultStates = {
    SD: 0,
    VT: 0
};
exports.pipDefaultStates = {
    KS: '4500',
    KY: '10000/0DED',
    ND: '30',
    OR: 'NONE'
};
exports.guestPIPDefaultStates = {
    KY: 'Not covered'
};
exports.noFaultPIPDefaultStates = {
    KY: 'Included'
};
exports.policyLimitUMPDDefaultStates = {
    VA: '20000'
};
exports.leaseLoanStates = {
    AL: { isBix: true, isNotBix: true },
    AZ: { isBix: true, isNotBix: false },
    CO: { isBix: true, isNotBix: true },
    IA: { isBix: true, isNotBix: true },
    ID: { isBix: true, isNotBix: true },
    IL: { isBix: true, isNotBix: false },
    IN: { isBix: true, isNotBix: true },
    KS: { isBix: true, isNotBix: true },
    KY: { isBix: true, isNotBix: true },
    MD: { isBix: true, isNotBix: true },
    MI: { isBix: true, isNotBix: true },
    MO: { isBix: true, isNotBix: false },
    ND: { isBix: true, isNotBix: true },
    NE: { isBix: true, isNotBix: true },
    NH: { isBix: true, isNotBix: true },
    NM: { isBix: true, isNotBix: true },
    OH: { isBix: true, isNotBix: false },
    OK: { isBix: true, isNotBix: true },
    OR: { isBix: true, isNotBix: true },
    PA: { isBix: true, isNotBix: true },
    SD: { isBix: true, isNotBix: true },
    TN: { isBix: true, isNotBix: true },
    TX: { isBix: true, isNotBix: false },
    UT: { isBix: true, isNotBix: true },
    VT: { isBix: true, isNotBix: true },
    WI: { isBix: true, isNotBix: true },
    WV: { isBix: true, isNotBix: true }
};
exports.advancedConnectedHomeStates = {
    AL: { isBix: true, isNotBix: true },
    AZ: { isBix: true, isNotBix: false },
    CO: { isBix: true, isNotBix: true },
    IA: { isBix: true, isNotBix: true },
    ID: { isBix: true, isNotBix: true },
    IL: { isBix: true, isNotBix: false },
    IN: { isBix: true, isNotBix: false },
    KS: { isBix: true, isNotBix: true },
    KY: { isBix: true, isNotBix: true },
    MD: { isBix: true, isNotBix: true },
    MI: { isBix: true, isNotBix: true },
    MO: { isBix: true, isNotBix: false },
    ND: { isBix: true, isNotBix: true },
    NE: { isBix: true, isNotBix: true },
    NH: { isBix: true, isNotBix: true },
    NM: { isBix: true, isNotBix: true },
    OH: { isBix: true, isNotBix: false },
    OK: { isBix: true, isNotBix: false },
    OR: { isBix: true, isNotBix: true },
    PA: { isBix: true, isNotBix: true },
    SD: { isBix: true, isNotBix: true },
    TN: { isBix: true, isNotBix: true },
    TX: { isBix: true, isNotBix: false },
    UT: { isBix: true, isNotBix: true },
    VT: { isBix: true, isNotBix: true },
    VA: { isBix: true, isNotBix: true },
    WI: { isBix: true, isNotBix: true },
    WV: { isBix: true, isNotBix: true }
};
exports.discountInventoryScoreStates = {
    AL: { isBix: true, isNotBix: true },
    AZ: { isBix: true, isNotBix: false },
    CO: { isBix: true, isNotBix: true },
    IA: { isBix: true, isNotBix: true },
    ID: { isBix: true, isNotBix: true },
    IL: { isBix: true, isNotBix: false },
    IN: { isBix: true, isNotBix: false },
    KS: { isBix: true, isNotBix: true },
    KY: { isBix: true, isNotBix: true },
    MD: { isBix: true, isNotBix: true },
    MI: { isBix: true, isNotBix: true },
    MO: { isBix: true, isNotBix: false },
    ND: { isBix: true, isNotBix: true },
    NE: { isBix: true, isNotBix: true },
    NH: { isBix: true, isNotBix: true },
    NM: { isBix: true, isNotBix: true },
    OH: { isBix: true, isNotBix: false },
    OR: { isBix: true, isNotBix: true },
    OK: { isBix: true, isNotBix: false },
    PA: { isBix: true, isNotBix: true },
    SD: { isBix: true, isNotBix: true },
    TN: { isBix: true, isNotBix: true },
    TX: { isBix: true, isNotBix: false },
    UT: { isBix: true, isNotBix: true },
    VT: { isBix: true, isNotBix: true },
    VA: { isBix: true, isNotBix: true },
    WI: { isBix: true, isNotBix: true },
    WV: { isBix: true, isNotBix: true }
};
exports.discountPaperlessStates = {
    AL: { isBix: true, isNotBix: true },
    AZ: { isBix: true, isNotBix: false },
    CO: { isBix: true, isNotBix: true },
    IA: { isBix: true, isNotBix: true },
    ID: { isBix: true, isNotBix: true },
    IL: { isBix: true, isNotBix: false },
    IN: { isBix: true, isNotBix: false },
    KS: { isBix: true, isNotBix: true },
    KY: { isBix: true, isNotBix: true },
    MD: { isBix: true, isNotBix: true },
    MI: { isBix: true, isNotBix: true },
    MO: { isBix: true, isNotBix: false },
    ND: { isBix: true, isNotBix: true },
    NE: { isBix: true, isNotBix: true },
    NH: { isBix: true, isNotBix: true },
    NM: { isBix: true, isNotBix: true },
    OH: { isBix: true, isNotBix: false },
    OK: { isBix: true, isNotBix: false },
    OR: { isBix: true, isNotBix: true },
    PA: { isBix: true, isNotBix: true },
    SD: { isBix: true, isNotBix: true },
    TN: { isBix: true, isNotBix: true },
    TX: { isBix: true, isNotBix: false },
    UT: { isBix: true, isNotBix: true },
    VA: { isBix: true, isNotBix: true },
    VT: { isBix: true, isNotBix: true },
    WI: { isBix: true, isNotBix: true },
    WV: { isBix: true, isNotBix: true }
};
exports.pipStates = {
    KS: true,
    KY: true,
    MD: true,
    ND: true,
    OR: true,
    TX: true,
    UT: true
};
exports.accidentalDeathStates = {
    PA: true,
    SD: true
};
exports.incomeLossLabelStates = {
    SD: 'Total Disability, Loss of Income'
};
exports.coverageRSLabelStates = {
    DC: 'Roof Surfaces',
    ME: 'Roof Surfaces',
    NH: 'Roof Surfaces',
    ND: 'Roof Surfaces',
    SD: 'Roof Surfaces',
    VT: 'Roof Surfaces'
};
exports.coverageRSDescriptionStates = {
    DC: 'Coverage for roof surfaces up to repair/replacement cost',
    ME: 'Coverage for roof surfaces up to repair/replacement cost. If you do not purchase this, roof claims will be handled with a payment schedule.',
    NH: 'Coverage for roof surfaces up to repair/replacement cost',
    ND: 'Coverage for roof surfaces up to repair/replacement cost',
    SD: 'Coverage for roof surfaces up to repair/replacement cost. If you do not purchase this, roof claims will be handled with a payment schedule.',
    VT: 'Coverage for roof surfaces up to repair/replacement cost'
};
// policy-level income loss here only:
exports.incomeLossStates = {
    PA: true,
    SD: true
};
exports.policyLevelAndCopyToCarUMPDStates = ['IN', 'MD', 'TN', 'VA', 'VT', 'WV'];
exports.umpdDeductibleByState = {
    ID: 250,
    MD: 250,
    NM: 250,
    OR: 200,
    TN: 200,
    UT: 250,
    VT: 150
};
exports.changeRejectionLangToNeedToTalkStates = { NH: true };
exports.communityDriveAvailableStates = {
    AL: { showForBix: true, showForNonBix: true },
    AZ: { showForBix: true, showForNonBix: false },
    CO: { showForBix: true, showForNonBix: true },
    IA: { showForBix: true, showForNonBix: true },
    ID: { showForBix: true, showForNonBix: true },
    IL: { showForBix: true, showForNonBix: false },
    IN: { showForBix: true, showForNonBix: true },
    KS: { showForBix: true, showForNonBix: true },
    KY: { showForBix: true, showForNonBix: true },
    MD: { showForBix: true, showForNonBix: true },
    MI: { showForBix: true, showForNonBix: true },
    MO: { showForBix: true, showForNonBix: false },
    ND: { showForBix: true, showForNonBix: true },
    NE: { showForBix: true, showForNonBix: true },
    NH: { showForBix: true, showForNonBix: true },
    NM: { showForBix: true, showForNonBix: true },
    OH: { showForBix: true, showForNonBix: false },
    OK: { showForBix: true, showForNonBix: true },
    OR: { showForBix: true, showForNonBix: true },
    PA: { showForBix: true, showForNonBix: true },
    SD: { showForBix: true, showForNonBix: true },
    TN: { showForBix: true, showForNonBix: true },
    TX: { showForBix: true, showForNonBix: false },
    UT: { showForBix: true, showForNonBix: true },
    VA: { showForBix: false, showForNonBix: false },
    VT: { showForBix: true, showForNonBix: true },
    WI: { showForBix: true, showForNonBix: true },
    WV: { showForBix: true, showForNonBix: true }
};
exports.errorCodes = {
    CHAT: 4000,
    EMAIL: 4001,
    POWER: 4002,
    NOTLIVE: 4003,
    NOT_ENOUGH_INFO: 4004,
    INVALIDINPUT: 4005,
    NEEDPRIORADDRESS: 5001,
    NEEDDATEOFBIRTH: 5002,
    NEEDCV: 5003,
    NEED360: 5004,
    NEEDCAR: 5005,
    INVALIDCAR: 5006,
    INVALIDQUOTE: 5007,
    INVALIDSTATE: 5008,
    WONTWRITECAR: 5009,
    INVALIDVIN: 5010,
    MORATORIUM: 5011,
    NEEDDRIVERSLICENSE: 5012,
    NOPOBOXADDRESS: 5013,
    MIN_PREMIUM: 5014,
    PRIMARYUDRNODRIVERSLICENSE: 5015,
    NEEDPERSONINFO: 5016,
    RESTRICTEDSTATE: 5017,
    SETFEES: 5018,
    UNKNOWN: 0
};
exports.rejectCodes = {
    // all codes from 10000 - 49999 are FCRA
    VERISK_GENERIC: 10000,
    VERISK_PROPERTY_CLAIMS_TOTAL: 10009,
    VERISK_PROPERTY_CLAIMS_SAME_PERIL: 10010,
    VERISK_PROPERTY_CLAIMS_OLDER_HOME: 10011,
    VERISK_PROPERTY_CLAIMS_BITE: 10012,
    VERISK_AUTO_CLAIMS_SUS: 10013,
    VERISK_AUTO_CLAIMS_DIS: 10014,
    VERISK_AUTO_CLAIMS_POLICY: 10015,
    VERISK_AUTO_CLAIMS_DRIVER: 10016,
    VERISK_PIP_CLAIMS: 10017,
    TU_DRIVERRISK_GENERIC: 20000,
    TU_DRIVERRISK_SUS: 20001,
    TU_DRIVERRISK_DIS: 20002,
    TU_DRIVERRISK_POLICY: 20003,
    TU_DRIVERRISK_DRIVER: 20004,
    // Non-FCRA rejections:
    NON_FCRA_GENERIC: 50000,
    NO_CARS: 50001,
    SQFT_HIGH: 50002,
    OCCUPANTS_HIGH: 50003,
    CAR_RATIO: 50004,
    YEARBUILT_OLD: 50005,
    VERISK_NO360: 50006,
    NO_PRIOR_AUTO_INSURANCE: 50007,
    VERISK_360_EIFS: 50008,
    VERISK_360_STILTS: 50009,
    VERISK_360_WOOD: 50010,
    VERISK_360_RCE_LOW: 50011,
    VERISK_360_RCE_HIGH: 50012,
    VERISK_PPC_10: 50013,
    VERISK_NO_PPC: 50014,
    TOO_MANY_DRIVERS: 50015,
    TOO_MANY_CARS: 50016,
    TEST_CASE: 50017,
    INELIGIBLE_COASTAL_LOCATION: 50018,
    VERISK_NO_FIRELINE: 50019,
    VERISK_FIRELINE_TOO_HIGH: 50020,
    VERISK_FIRELINE_PLUS_FPC_TOO_HIGH: 50021,
    NO_DTC: 50022,
    INELIGIBLE_DTC: 50023,
    SPP_OVER_10PCT_COVC: 50024,
    SPP_OVER_10PCT_COVA: 50025,
    SPP_TOTAL_OVER_50PCT_COVC: 50026,
    NO_HOME_WIND_HAIL_EXCLUSION: 50027,
    VERISK_PPC_TOO_HIGH: 50028,
    DID_NOT_ASK_FOR_AUTO: 50029
};
// Specific set of Reject Codes that are set somewhere but need to be cleared in Staff
exports.rejectCodesToBeClearedInStaff = [exports.rejectCodes.NO_HOME_WIND_HAIL_EXCLUSION];
exports.fixableRejectionCodes = [50001, 50004, 50006, 50014, 50015, 500016, 50022];
exports.coverageFOffered = {
    AL: true,
    AZ: false,
    CO: true,
    IA: true,
    ID: true,
    IL: true,
    IN: true,
    KS: true,
    KY: true,
    MD: true,
    MI: true,
    MO: true,
    ND: true,
    NE: true,
    NH: true,
    NM: true,
    OH: true,
    OK: true,
    OR: true,
    PA: true,
    SD: true,
    TN: true,
    TX: true,
    UT: true,
    VA: true,
    VT: true,
    WI: true,
    WV: true
};
exports.coverageDNotOffered = {
    NH: true,
    SD: true,
    VT: true
};
exports.coverageCANotOffered = {
    VA: true
};
exports.coverageDRNotOffered = {
    ID: true,
    NH: true,
    TN: true,
    SD: true,
    VT: true
};
exports.coverageMINotOffered = {
    VA: true
};
exports.coverageSTNotOffered = {
    ND: true,
    NH: true,
    VA: true,
    VT: true
};
exports.coverageSPNotOffered = {
    VA: true
};
exports.coverageFairRentalNotOffered = {
    VA: true
};
exports.coverageYardAndGardenNotOffered = {
    SD: true,
    VA: true
};
exports.coverageHomeownerProtectionNotOffered = {
    ND: true,
    VA: true
};
exports.offerExcessUM = {
    AL: true,
    AZ: true,
    CO: false,
    IA: true,
    ID: false,
    IL: false,
    IN: true,
    KS: false,
    KY: false,
    MD: true,
    MI: false,
    MO: false,
    ND: false,
    NE: true,
    NH: true,
    NM: false,
    OH: true,
    OK: true,
    OR: true,
    PA: false,
    SD: false,
    TN: false,
    TX: false,
    UT: false,
    VA: true,
    VT: true,
    WI: true,
    WV: true
};
exports.additionalPPCIneligibleByState = {
    SD: ['8', '8B', '9', '10']
};
exports.firelineCutoffsByState = {
    CO: {
        firelineAlone: 14,
        firelineWithPPC: 4
    },
    OR: {
        firelineAlone: 14,
        firelineWithPPC: 4
    }
};
exports.buildingMaterialsTheftCoverageByState = {
    ND: 5000,
    NH: 5000,
    SD: 5000,
    WV: 5000
};
exports.mineSubsidenceMaxStates = {
    KY: 300000,
    WV: 300000
};
exports.mineSubsidenceStates = {
    IL: {
        deductible: 'AOP'
    },
    IN: {
        deductible: '2%'
    },
    KY: {
        deductible: '250'
    },
    OH: {
        deductible: '2%'
    },
    WV: {
        deductible: '250'
    }
};
exports.mineSubsidenceDefaulted = {
    IL: {
        BOND: true,
        BUREAU: true,
        CHRISTIAN: true,
        CLINTON: true,
        DOUGLAS: true,
        FRANKLIN: true,
        FULTON: true,
        GALLATIN: true,
        GRUNDY: true,
        ISLAND: true,
        JACKSON: true,
        JEFFERSON: true,
        KNOX: true,
        LASALLE: true,
        LOGAN: true,
        MACOUPIN: true,
        MADISON: true,
        MARION: true,
        MARSHALL: true,
        MCDONOUGH: true,
        MENARD: true,
        MERCER: true,
        MONTGOMERY: true,
        PEORIA: true,
        PERRY: true,
        PUTNAM: true,
        RANDOLPH: true,
        ROCK: true,
        'ROCK ISLAND': true,
        'SAINT CLAIR': true,
        SALINE: true,
        SANGAMON: true,
        'ST CLAIR': true,
        'ST. CLAIR': true,
        TAZEWELL: true,
        VERMILLION: true,
        WASHINGTON: true,
        WILLIAMSON: true
    }
};
exports.mineSubsidenceOptional = {
    IL: {
        all: true
    },
    IN: {
        CLAY: true,
        CRAWFORD: true,
        DAVIES: true,
        DAVIESS: true,
        DUBOIS: true,
        FOUNTAIN: true,
        GIBSON: true,
        GREENE: true,
        KNOX: true,
        LAWRENCE: true,
        MARTIN: true,
        MONROE: true,
        MONTGOMERY: true,
        ORANGE: true,
        OWEN: true,
        PARKE: true,
        PERRY: true,
        PIKE: true,
        POSEY: true,
        PUTNAM: true,
        SPENCER: true,
        SULLIVAN: true,
        VANDERBURG: true,
        VANDERBURGH: true,
        VERMILION: true,
        VERMILLION: true,
        VIGO: true,
        WARREN: true,
        WARRICK: true
    },
    KY: {
        BELL: true,
        BOYD: true,
        BREATHITT: true,
        BUTLER: true,
        CARTER: true,
        CHRISTIAN: true,
        CLAY: true,
        DAVIESS: true,
        EDMONSON: true,
        ELLIOT: true,
        FLOYD: true,
        GREENUP: true,
        HANCOCK: true,
        HARLAN: true,
        HENDERSON: true,
        HOPKINS: true,
        JACKSON: true,
        JOHNSON: true,
        KNOTT: true,
        KNOX: true,
        LAUREL: true,
        LAWRENCE: true,
        LEE: true,
        LETCHER: true,
        LESLIE: true,
        MARTIN: true,
        MCCREARY: true,
        MCLEAN: true,
        MORGAN: true,
        MUHLENBERG: true,
        OHIO: true,
        OWSLEY: true,
        PERRY: true,
        UNION: true,
        WEBSTER: true,
        WHITLEY: true,
        WOLFE: true
    },
    OH: {
        DELAWARE: true,
        ERIE: true,
        GEAUGA: true,
        LAKE: true,
        LICKING: true,
        MEDINA: true,
        OTTAWA: true,
        PORTAGE: true,
        PREBLE: true,
        SUMMIT: true,
        WAYNE: true
    },
    WV: {
        BERKELEY: true,
        CABELL: true,
        CALHOUN: true,
        HAMPSHIRE: true,
        HARDY: true,
        JACKSON: true,
        JEFFERSON: true,
        MONROE: true,
        MORGAN: true,
        PENDLETON: true,
        PLEASANTS: true,
        RITCHIE: true,
        ROANE: true,
        WIRT: true,
        WOOD: true
    }
};
exports.mineSubsidenceRequired = {
    KY: {
        // stub placeholder to make this clear
        NONE: true
    },
    IN: {
        // stub placeholder to make this clear
        NONE: true
    },
    OH: {
        ATHENS: true,
        BELMONT: true,
        CARROLL: true,
        COLUMBIANA: true,
        COSHOCTON: true,
        GALLIA: true,
        GUERNSEY: true,
        HARRISON: true,
        HOCKING: true,
        HOLMES: true,
        JACKSON: true,
        JEFFERSON: true,
        LAWRENCE: true,
        MAHONING: true,
        MEIGS: true,
        MONROE: true,
        MORGAN: true,
        MUSKINGUM: true,
        NOBLE: true,
        PERRY: true,
        SCIOTO: true,
        STARK: true,
        TRUMBULL: true,
        TUSCARAWAS: true,
        VINTON: true,
        WASHINGTON: true
    },
    WV: {
        BARBOUR: true,
        BOONE: true,
        BRAXTON: true,
        BROOKE: true,
        CLAY: true,
        DODDRIDGE: true,
        FAYETTE: true,
        GILMER: true,
        GRANT: true,
        GREENBRIER: true,
        HANCOCK: true,
        HARRISON: true,
        KANAWHA: true,
        LEWIS: true,
        LINCOLN: true,
        LOGAN: true,
        MCDOWELL: true,
        MARION: true,
        MARSHALL: true,
        MASON: true,
        MERCER: true,
        MINERAL: true,
        MINGO: true,
        MONONGALIA: true,
        NICHOLAS: true,
        OHIO: true,
        POCAHONTAS: true,
        PRESTON: true,
        PUTNAM: true,
        RALEIGH: true,
        RANDOLPH: true,
        SUMMERS: true,
        TAYLOR: true,
        TUCKER: true,
        TYLER: true,
        UPSHUR: true,
        WAYNE: true,
        WEBSTER: true,
        WETZEL: true,
        WYOMING: true
    }
};
exports.ineligibleCoastalCities = {
    TX: {
        ARANSAS: { all: true },
        BRAZORIA: { all: true },
        CALHOUN: { all: true },
        CAMERON: { all: true },
        CHAMBERS: { all: true },
        GALVESTON: { all: true },
        HARRIS: {
            'LA PORTE': true,
            LAPORTE: true,
            "MORGAN'S POINT": true,
            'MORGANS POINT': true,
            MORGANSPOINT: true,
            PASADENA: true,
            SEABROOK: true,
            SHOREACRES: true
        },
        JEFFERSON: { all: true },
        KENEDY: { all: true },
        KLEBERG: { all: true },
        MATAGORDA: { all: true },
        NUECES: { all: true },
        REFUGIO: { all: true },
        'SAN PATRICIO': { all: true },
        WILLACY: { all: true }
    }
};
exports.coastalCounties = {
    TX: {
        HARDIN: true,
        JEFFERSON: true,
        ORANGE: true,
        AUSTIN: true,
        BRAZORIA: true,
        CHAMBERS: true,
        COLORADO: true,
        'FORT BEND': true,
        GALVESTON: true,
        HARRIS: true,
        LIBERTY: true,
        MATAGORDA: true,
        MONTGOMERY: true,
        WALKER: true,
        WALLER: true,
        WHARTON: true,
        CALHOUN: true,
        DEWITT: true,
        GOLIAD: true,
        GONZALES: true,
        JACKSON: true,
        LAVACA: true,
        VICTORIA: true,
        ARANSAS: true,
        BEE: true,
        BROOKS: true,
        DUVAL: true,
        'JIM WELLS': true,
        KENEDY: true,
        KLEBURG: true,
        KLEBERG: true,
        'LIVE OAK': true,
        NUECES: true,
        REFUGIO: true,
        'SAN PATRICIO': true,
        CAMERON: true,
        HIDALGO: true,
        WILLACY: true
    }
};
exports.mandatoryWindHailDeductibleValueMinimumStates = {
    MD: 2500
};
exports.mandatoryWindHailDeductibleByZip = {};
exports.mandatoryWindHailDeductibleByCounty = {
    MD: {
        ALLEGANY: 2500,
        GARRETT: 2500,
        WASHINGTON: 2500,
        FREDERICK: 2500,
        CARROLL: 2500,
        HOWARD: 2500,
        MONTGOMERY: 2500,
        CHARLES: 0.01,
        'PRINCE GEORGES': 0.01,
        "PRINCE GEORGE'S": 0.01,
        'ANNE ARUNDEL': 0.01,
        BALTIMORE: 0.01,
        'BALTIMORE COUNTY': 0.01,
        'BALTIMORE CITY': 0.01,
        HARFORD: 0.01,
        CECIL: 0.01,
        KENT: 0.01,
        'QUEEN ANNES': 0.01,
        "QUEEN ANNE'S": 0.01,
        CAROLINE: 0.01,
        CALVERT: 0.02,
        'ST MARYS': 0.02,
        'ST. MARYS': 0.02,
        'SAINT MARYS': 0.02,
        "ST. MARY'S": 0.02,
        "ST MARY'S": 0.02,
        "SAINT MARY'S": 0.02,
        TALBOT: 0.02,
        DORCHESTER: 0.02,
        WICOMICO: 0.02,
        SOMERSET: 0.02,
        WORCESTER: 0.02
    }
};
exports.windHailDeductibleIsAlwaysPercent = {
    MO: true
};
exports.aopDeductibleIsAlwaysPercent = {
    TN: false
};
exports.windHailDeductibleCanVaryByCounty = {
    GA: {
        BRYAN: true,
        CAMDEN: true,
        GLYNN: true,
        LIBERTY: true,
        MCINTOSH: true
    }
};
exports.noWindHailDeductibleStates = {
    ND: true,
    SD: true,
    NH: true,
    TN: true,
    VT: true
};
exports.rentersPolicyAvailable = {
    AL: true,
    AZ: false,
    CO: false,
    IA: true,
    ID: true,
    IL: true,
    IN: true,
    KS: false,
    KY: false,
    MD: false,
    MI: false,
    MO: true,
    ND: false,
    NE: true,
    NH: false,
    NM: false,
    OH: true,
    OK: true,
    OR: true,
    PA: false,
    SD: false,
    TN: false,
    TX: false,
    UT: true,
    VA: true,
    VT: false,
    WI: true,
    WV: true
};
exports.pipCheckStates = {
    KY: true
};
exports.localPremiumTaxStates = {
    KY: true
};
exports.statePremiumTaxStates = {
    KY: true
};
exports.minimumDrivingAge = {
    AL: 15,
    AK: 14,
    AZ: 15,
    AR: 14,
    CA: 15,
    CO: 15,
    CT: 16,
    DE: 16,
    DC: 16,
    FL: 15,
    GA: 15,
    HI: 14,
    ID: 14,
    IL: 15,
    IN: 15,
    IA: 14,
    KS: 14,
    KY: 16,
    LA: 15,
    ME: 15,
    MD: 15,
    MA: 16,
    MI: 14,
    MN: 15,
    MS: 15,
    MO: 15,
    MT: 14,
    NE: 15,
    NV: 15,
    NH: 15,
    NJ: 16,
    NM: 16,
    NY: 16,
    NC: 15,
    ND: 14,
    OH: 15,
    OK: 15,
    OR: 15,
    PA: 16,
    RI: 16,
    SC: 15,
    SD: 14,
    TN: 15,
    TX: 15,
    UT: 15,
    VT: 15,
    VA: 15,
    WA: 15,
    WV: 15,
    WI: 15,
    WY: 15
};
exports.vehicleEquipmentStatusCode = {
    OPTIONAL: 'O',
    STANDARD: 'S',
    NO: 'N'
};
exports.HomeSecurityPartnerCustomerType = {
    CURRENT: 'C',
    NEW_BRANCH: 'B'
};
exports.mortgageHoldersAffinities = [
    {
        name: 'QUICKEN LOANS INC ISAOA',
        affinity: 'QL1'
    }
];
exports.mortgageClauses = {
    RM1: {
        correctName: 'T2 FINANCIAL LLC DBA/ REVOLUTION MORTGAGE ISAOA/ATIMA',
        address: '480 Olde Worthington Road',
        address2: 'Ste 300',
        city: 'Westerville',
        state: 'OH',
        zip: '43082'
    }
};
exports.newCustomersDefaultDevices = {
    ADT: {
        moistureDevices: 2,
        theftPreventionDevices: 2,
        motionDetectingDevices: 1,
        smokeDetectingDevices: 2,
        autoWaterShutoffDevices: false
    },
    SimpliSafe: {
        moistureDevices: 1,
        theftPreventionDevices: 1,
        motionDetectingDevices: 1,
        smokeDetectingDevices: 1,
        autoWaterShutoffDevices: false
    }
};
exports.connectedHomePromoDetails = {
    SimpliSafe: {
        promoItems: [
            '7-piece security system guards against break-ins and fires--plus includes 24/7 video monitoring. A $403 value, yours FREE.',
            'Monitored by professionals 24/7 for only $17.99/month - with NO long-term contract. Your first month is FREE.',
            'Ranked the best overall home security system of 2021 by U.S. News and World Report'
        ],
        privacyPolicyUrl: 'https://simplisafe.com/privacy'
    },
    ADT: {
        promoItems: [
            'Get ADTs best offer PLUS receive 2 flood detectors FREE (Requires 36 month monitoring contract. Early termination and installation fees apply.)',
            'ADT is the # 1 smart home security provider in the U.S. (Source: Strategy Analytics, 2020)',
            '$0 Down*** 0% Interest 100% Real Protection. Now you can get the security you need with the smart home devices you want with $0 down and flexible, easy, low monthly payments on professionally installed equipment. (***Requires 0% APR installment agreement with equal monthly payments based on term/equipment selected. Well-qualified credit. Requires monthly monitoring contract for finance term selected. Early term fees apply.)'
        ],
        privacyPolicyUrl: 'https://www.adt.com/about-adt/legal/privacy-policy'
    },
    Kangaroo: {
        privacyPolicyUrl: 'https://info.heykangaroo.com/legal#legal-privacy-policy'
    }
};
exports.HighestEducation = {
    H: 'High School or less',
    S: 'Some College',
    A: 'Associates Degree',
    B: 'Bachelors Degree',
    M: 'Masters Degree',
    D: 'Doctoral Degree'
};
exports.ratingSeriousness = {
    AAF: 4,
    AFM: 0,
    ANC: 0,
    ANO: 0,
    ASW: 0,
    BOT: 1,
    CCW: 0,
    CML: 2,
    CMP: 0,
    CMU: 0,
    CRD: 4,
    DEV: 2,
    DEQ: 2,
    DR: 8,
    DWI: 8,
    FAR: 2,
    FDL: 2,
    FEL: 8,
    FFR: 8,
    FLE: 8,
    FRA: 2,
    FTC: 2,
    FTY: 2,
    HOM: 8,
    IBK: 2,
    IP: 2,
    IT: 2,
    LDL: 4,
    LIC: 2,
    LTS: 4,
    MAJ: 4,
    MMV: 2,
    NAF: 0,
    NFX: 0,
    PUA: 0,
    PUN: 0,
    REF: 1,
    RKD: 8,
    SAF: 2,
    SCH: 2,
    SLV: 4,
    SPD: 2,
    SUS: 10,
    TMP: 0,
    UDR: 4,
    WSR: 2
};
exports.monarchPoints = {
    AAF: 3,
    CMP: 2,
    NAF: 1
};
exports.homeClaimPoints = {
    D: 4,
    G: 3,
    E: 2,
    F: 1
};
exports.connectedHomeProvidersAllowingVerification = ['ADT'];
exports.violationCodeToDescription = {
    AAF: 'Accident found on MVR only at renewal - Not Chargeable',
    ANC: 'Waived Claim - Closed',
    ANO: 'Waived Claim - Open',
    ASW: 'Accident Surcharge Waived',
    BOT: 'Comprehensive Claim',
    CCW: 'Comprehensive Claim - Weather',
    CMU: 'Comprehensive Claim Less Than or Equal to $1,000',
    CRD: 'Careless or Improper Driving',
    DEQ: 'Defective Equipment',
    DEV: 'Traffic Device /Sign',
    DR: 'Driving Under The Influence of Alcohol/Drugs',
    FAR: 'False Reporting or Perjury',
    FDL: `Foreign Driver's License`,
    FEL: 'Auto Theft or Felony Involving a Motor Vehicle',
    FLE: 'Fleeing or Eluding the Police',
    FRA: 'Failure to Report an Accident',
    FTC: 'Following Too Close',
    FTY: 'Improper or Illegal Passing',
    IT: `Operating Without Owner's Consent`,
    LIC: 'License or Credentials Violation',
    LTS: 'Minor Moving Violation',
    NAF: 'Not At Fault Accident',
    NFX: 'Waived Not At Fault Accident',
    PUA: 'Permissive Use At Fault Accident',
    PUN: 'Permissive Use Not At Fault Accident',
    REF: 'Passing of a School Bus',
    SLV: 'Serious License Violation',
    SPD: 'Speeding',
    TMP: 'Dispute – At Fault Accident',
    UDR: 'Unverifiable Record',
    WSR: 'Wrong Way on a One Way Street'
};
exports.homeClaimCodeToDescription = {
    D: 'Fire',
    E: 'Theft, Liability, Vandlism',
    F: 'All Other Claims (not Fire, Water, Theft, Liability or Vandalism)',
    G: 'Water'
};
exports.fpcClassesImpactingPrice = ['7', '8', '8B', '9'];
exports.financialResponsibilityTiersImpactingPrice = ['L-1', 'M-1', 'N-1', 'O-1', 'P-1', 'Q-1', 'R-1'];
exports.priorLapseDays = { TX: 32 };
exports.policyType = { Home: 'H', Auto: 'A', ARBundle: 'AR', HABundle: 'HA' };
exports.planType = { Standard: 'S', Economy: 'E', Premium: 'P', Custom: 'C' };
exports.paymentMethod = { CreditCard: 'C', ACH: 'E', Escrow: 'W' };
exports.paymentType = { Monthly: 'I', OneTime: 'F', Escrow: 'E' };
exports.stripeBankStatus = {
    New: 'new',
    Validated: 'validated',
    Verified: 'verified',
    VerificationFailed: 'verification_failed',
    Errored: 'errored'
};
// status on stripe-specific charges/transactions
exports.stripeChargeStatus = {
    Succeeded: 'succeeded',
    Pending: 'pending',
    Failed: 'failed'
};
// status on transactions when they are retrieved from billingHandler.getChargeDeskTransactions()
exports.normalizedPaymentStatus = {
    Paid: 'paid',
    Pending: 'pending',
    Refunded: 'refunded',
    PartiallyRefunded: 'partially refunded',
    Failed: 'failed'
};
exports.onboardingTasks = {
    StressFreeSwitchHome: 'StressFreeSwitchHome',
    StressFreeSwitchAuto: 'StressFreeSwitchAuto'
};
exports.cancelNoticeParagraphText = [
    {
        cancelNoticeName: 'CNRS',
        paragraphText: "We'll be happy to reinstate your policy if we receive the information requested above prior to cancellation. Just give us a call or, if you prefer, fax or mail the requested information along with a copy of this page to Branch. But don't delay. We won't be able to reinstate your policy if you contact us after the deadline."
    },
    {
        cancelNoticeName: 'CNPY',
        paragraphText: "Unfortunately, we didn't receive your payment and, as a result, your policy will be cancelled at 12:01 a.m. on [endDate]. Please know that this means you will no longer have insurance coverage. If you've already sent your payment, thank you. Your next regular payment will be due on [minimumAmountDueDate]. You can also pay online or over the phone using a credit card or authorizing a withdrawal from your bank account. We'll credit your payment right away so your insurance coverage will continue. We sincerely appreciate your attention to this matter and thank you for your business."
    }
];
exports.cancelCodeInformationalArray = [
    {
        cancelCode: 'CNDC',
        cancelReasonPlainText: 'Customer Dissatisfied with Claims',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Claims'
    },
    {
        cancelCode: 'CNPR',
        cancelReasonPlainText: 'Customer Dissatisfied with Price',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Price'
    },
    {
        cancelCode: 'CNDR',
        cancelReasonPlainText: 'Customer Dissatisfied with Roadside',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Roadside'
    },
    {
        cancelCode: 'CNDB',
        cancelReasonPlainText: 'Customer Dissatisfied with Service',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Service'
    },
    {
        cancelCode: 'CNDA',
        cancelReasonPlainText: 'Customer Dissatisfied with Agency',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Dissatisfied with Agency'
    },
    {
        cancelCode: 'CNMS',
        cancelReasonPlainText: 'Customer Misrepresentation',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Misrepresentation'
    },
    {
        cancelCode: 'CNPY',
        cancelReasonPlainText: 'Customer Non-Payment',
        cancelNoticeName: 'CNPY',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Non-Payment'
    },
    {
        cancelCode: 'CNID',
        cancelReasonPlainText: 'Documents Not Signed',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Documents Not Signed'
    },
    {
        cancelCode: 'CNCN',
        cancelReasonPlainText: 'Ineligible Condition of Home',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Ineligible Condition of Home'
    },
    {
        cancelCode: 'CNMV',
        cancelReasonPlainText: 'Moving, Branch Eligible',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Moving'
    },
    {
        cancelCode: 'CNMI',
        cancelReasonPlainText: 'Moving, Branch Ineligible',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Moving, Branch Ineligible'
    },
    {
        cancelCode: 'CNNO',
        cancelReasonPlainText: 'Other Customer Cancellation',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Insured Request - Other'
    },
    {
        cancelCode: 'CNUW',
        cancelReasonPlainText: 'Other Underwriting',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Underwriting Reasons'
    },
    {
        cancelCode: 'CNSO',
        cancelReasonPlainText: "Sold the Insured Property/Didn't Purchase",
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Sold the Insured Property'
    },
    {
        cancelCode: 'CNDP',
        cancelReasonPlainText: 'Duplicate Policy',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Duplicate Policy'
    },
    {
        cancelCode: 'CNIP',
        cancelReasonPlainText: 'Invalid Policy',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Invalid Policy'
    },
    {
        cancelCode: 'CNPP',
        cancelReasonPlainText: 'No Proof of Prior',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: No Proof of Prior Insurance'
    },
    {
        cancelCode: 'CNAP',
        cancelReasonPlainText: 'Accidental Purchase',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Accidental Purchase'
    },
    {
        cancelCode: 'CNBX',
        cancelReasonPlainText: 'Customer Convert to Bix',
        // no cancellation docs generated for CNBX
        cancelNoticeName: '',
        boxOneText: '',
        boxTwoText: ''
    },
    {
        cancelCode: 'CNNR',
        cancelReasonPlainText: 'Non-renewal',
        cancelNoticeName: 'NRRS',
        boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Non-renewal: [fill in]',
        nonRenew: true
    },
    {
        cancelCode: 'CNDE',
        cancelReasonPlainText: 'Customer Deceased',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Deceased'
    },
    {
        cancelCode: 'NA',
        cancelReasonPlainText: 'Unknown',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: [Fill In]'
    },
    {
        cancelCode: 'CNAG',
        cancelReasonPlainText: 'Agency Book Roll',
        cancelNoticeName: 'NRRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Previous Agency Policy'
    },
    {
        cancelCode: 'CNBN',
        cancelReasonPlainText: 'BIX Forced Non-Renewal',
        cancelNoticeName: 'NRRS',
        boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason For Nonrenewal: General Security National Insurance Company is no longer offering policies in your state. ',
        nonRenew: true
    },
    {
        cancelCode: 'CNDY',
        cancelReasonPlainText: 'Bix Opt out',
        cancelNoticeName: 'CNRS',
        boxOneText: 'Your policy will be cancelled as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Cancellation: Opt Out of BIX Policy '
    },
    {
        cancelCode: 'NRUW',
        cancelReasonPlainText: 'Non-Renewal For Home Underwriting Reasons',
        cancelNoticeName: 'NRRS',
        boxOneText: 'Your policy will be non-renewed as of 12:01 A.M on [end date] ',
        boxTwoText: 'Reason(s) for Non-Renewal: [Fill In]',
        nonRenew: true
    }
];
exports.passiveRestraintStates = ['PA'];
exports.specificDriverAgeLogicStates = ['AL', 'SD', 'VT'];
exports.stormShuttersStates = ['AL', 'MD', 'OK', 'TX', 'VA'];
exports.editableHouseholdMembersStates = ['IA', 'KS', 'NM', 'OR', 'SD'];
exports.uimCoverageTypeStates = ['GA'];
exports.earthquakeStates = ['KY', 'CA'];
exports.palomarErrorPreventPurchasingStates = ['CA'];
exports.floodStates = ['TN', 'CA'];
exports.annualMilesDrivenLimits = {
    IA: {
        max: 30000,
        step: 1000
    },
    NE: {
        max: 30000,
        step: 1000
    },
    OR: {
        max: 30000,
        step: 1000
    },
    SD: {
        max: 30000,
        step: 1000
    }
};
exports.excludeBIXMonolineUnderwritingStates = [];
exports.hideHighestEducationStates = ['CA', 'FL', 'GA', 'ID', 'KS', 'MA', 'NY', 'WY'];
exports.hideGenderStates = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
];
exports.mustRenewAutoLimit = {
    WV: {
        A: 4,
        H: 4
    }
};
exports.equipmentBreakdownServiceLineCoveragesStates = ['IA', 'OH', 'AZ'];
exports.driversLicenseRegexByState = {
    AB: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    AK: {
        regex: new RegExp('^[0-9]{1,7}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 to 7 numbers'
    },
    AL: {
        regex: new RegExp('^[0-9]{7,10}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 7 to 10 numbers'
    },
    AR: {
        regex: new RegExp('^\\d{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers'
    },
    AZ: {
        regex: new RegExp('^(([a-z][0-9]{8})|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers or 1 letter + 8 numbers or Social Security number'
    },
    BC: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    CA: {
        regex: new RegExp('^[a-z]\\d{7}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 7 numbers'
    },
    CO: {
        regex: new RegExp('^\\d{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers or 1 letter + up to 6 numbers'
    },
    CT: {
        regex: new RegExp('^\\d{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers'
    },
    DC: {
        regex: new RegExp('^(([a-z]{2}\\d{8})|(\\d{7})|(\\d{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 2 letters + 8 numbers, or 7 numbers, or Social Security number'
    },
    DE: {
        regex: new RegExp('^[0-9]{1,7}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 to 7 numbers'
    },
    FL: {
        regex: new RegExp('^[a-z]\\d{11,12}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 11-12 numbers'
    },
    GA: {
        regex: new RegExp('^[0-9]{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers'
    },
    HI: {
        regex: new RegExp('^((\\d{9})|([H][0-9]{8}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of letter H + 8 numbers or Social Security number'
    },
    IA: {
        regex: new RegExp('^((\\d{9})|(\\d{3}[a-z]{2}\\d{4}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers or 9 numbers/letters (4th and 5th characters are letters)'
    },
    ID: {
        regex: new RegExp('^(([a-z]{2}[0-9]{6}[a-z])|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 2 letters + 6 numbers + 1 letter or 9 numbers (issued prior to 5/1/93)'
    },
    IL: {
        regex: new RegExp('^[a-z][0-9]{11}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 11 numbers'
    },
    IN: {
        regex: new RegExp('^(([a-z]\\d{9})|(\\d{10}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 10 numbers or 1 letter + 9 numbers'
    },
    KS: {
        regex: new RegExp('^((\\d{9})|([a-z]\\d{8})|([a-z0-9]{6}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 6 numbers/letters or 9 numbers or Social Security number or 1 leter + 9 numbers'
    },
    KY: {
        regex: new RegExp('^(([a-z][0-9]{8})|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 8 numbers or Social Security number'
    },
    LA: {
        regex: new RegExp('^[0-9]{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers. If less than 9 numbers, fill in with zeros on the front end'
    },
    MA: {
        regex: new RegExp('^(([a-z]{2}[0-9]{7})|([a-z][0-9]{8})|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers or 1 letter/number + 8 numbers'
    },
    MB: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    MD: {
        regex: new RegExp('^(([a-z][0-9]{12})|(md\\d{11}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 12 numbers, or "MD" followed by 11 digits'
    },
    ME: {
        regex: new RegExp('^(\\d{7})$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 7 numbers'
    },
    MI: {
        regex: new RegExp('^[a-z]\\d{12}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 12 numbers'
    },
    MN: {
        regex: new RegExp('^[a-z]\\d{12}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 12 numbers'
    },
    MO: {
        regex: new RegExp('^(([a-z][a-z0-9]{5,9})|([0-9]{9,10})|([0-9]{9}[a-z])|([a-z][0-9]{15,16})|([a-z][0-9]{15}[a-z]))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 to 10 numbers or 9 numbers + 1 letter or 1 letter + 15 to 16 numbers or 1 letter + 15 numbers + 1 letter or 1 letter + 5 to 9 letters/numbers'
    },
    MS: {
        regex: new RegExp('^[0-9]{9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers'
    },
    MT: {
        regex: new RegExp('^(([a-z0-9]{9})|([0-9]{13}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 13 numbers or 9 numbers or 9 letters/numbers'
    },
    NB: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    NC: {
        regex: new RegExp('^[0-9]{1,12}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 to 12 numbers'
    },
    ND: {
        regex: new RegExp('^(([a-z]{3}[0-9]{6})|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 3 letters + 6 numbers or Social Security number'
    },
    NE: {
        regex: new RegExp('^[a-z][0-9]{3,8}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 3-8 numbers'
    },
    NF: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    NH: {
        regex: new RegExp('^[a-z0-9]{10}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 10 letters/numbers'
    },
    NJ: {
        regex: new RegExp('^[a-z][0-9]{14}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 14 numbers '
    },
    NM: {
        regex: new RegExp('^[0-9]{8,9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 8 to 9 numbers '
    },
    NS: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    NT: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    NV: {
        regex: new RegExp('^(([0-9]{9,10})|([0-9]{12})|(X[0-9]{8})|([0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 to 10 numbers or 12 numbers or X + 8 numbers or Social Security number '
    },
    NY: {
        regex: new RegExp('^(([0-9]{9})|([a-z][0-9]{16,20}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 9 numbers or 1 letter + 16 to 20 numbers or 16 - 20 numbers'
    },
    OH: {
        regex: new RegExp('^([a-z]{2}[0-9]{6})$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 2 letters + 6 numbers'
    },
    OK: {
        regex: new RegExp('^([a-z]{1}[0-9]{9})$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 9 numbers'
    },
    ON: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    OR: {
        regex: new RegExp('^(([0-9]{1,7})|([a-z][0-9]{6})|([a-z]{2}[0-9]{5}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 to 7 numbers or 1 letter + 6 numbers or 2 letters + 5 numbers'
    },
    PA: {
        regex: new RegExp('^[0-9]{8}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 8 numbers'
    },
    PE: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    PQ: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    RI: {
        regex: new RegExp('^(([V][0-9]{6})|([0-9]{7}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 7 numbers or V + 6 numbers'
    },
    SC: {
        regex: new RegExp('^[0-9]{1,10}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 to 10 numbers'
    },
    SD: {
        regex: new RegExp('^(([0-9]{6})|([0-9]{8,9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 6 or 8 to 9 numbers'
    },
    SK: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    },
    TN: {
        regex: new RegExp('^[0-9]{8,9}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 8 to 9 numbers'
    },
    TX: {
        regex: new RegExp('^[0-9]{8}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 8 numbers'
    },
    UT: {
        regex: new RegExp('^(([0-9]{4,9})|(0[0-9]{9}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 4 to 9 numbers or 10 numbers (first position must be 0)'
    },
    VA: {
        regex: new RegExp('^(([a-z][0-9]{8})|([0-9]{9})|([0-9]{12}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 12 numbers or 1 letter + 8 numbers or Social Security number'
    },
    VT: {
        regex: new RegExp('^[0-9]{7}[A0-9]$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 8 numbers or 7 numbers + A'
    },
    WA: {
        regex: new RegExp('^[a-z0-9]{12}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 12 letters/numbers'
    },
    WI: {
        regex: new RegExp('^[a-z][0-9]{13}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 13 numbers'
    },
    WV: {
        regex: new RegExp('^(([ABCDEFISX][0-9]{6})|([X1][X][0-9]{5})|([a-z][0-9]{6})|([0-9]{7}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: 'Must consist of 1 letter + 6 numbers or 2 letters + 5 numbers or 1 letter + 1 number + 5 numbers or 7 numbers'
    },
    WY: {
        regex: new RegExp('^(([0-9]{9})|([0-9]{6}[-][0-9]{3}))$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: "Must consist of 9 numbers or 6 numbers then a '-' then 3 more numbers"
    },
    YT: {
        regex: new RegExp('^.{2,16}$', 'i'),
        commonErrorMessage: 'Driver License Number is not valid.',
        errorMessage: ''
    }
};
//# sourceMappingURL=constants.js.map